import { Link } from 'react-router-dom';
import { Gauge, Globe, ChevronRight } from 'lucide-react';
import { PageHeader } from '@/components/ui/PageHeader';
import { ProfileSection, BundleSection } from '@/components/profiles/ProfileSection';

export default function DataProfiles() {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <PageHeader
        title="Forfaits Data"
        subtitle="Profils de bande passante + WAN access (VLAN data, DHCP / PPPoE / static)"
        actions={
          <Link to="/app/profiles/voice" className="btn btn-sm">
            Forfaits Voix <ChevronRight size={11} />
          </Link>
        }
      />

      <div className="flex-1 overflow-auto p-4 flex flex-col gap-4">
        {/* Quick stats banner */}
        <div className="grid grid-cols-3 gap-3">
          <StatTile icon={<Gauge size={14} />} label="Bandwidth" color="text-c1" />
          <StatTile icon={<Globe size={14} />} label="WAN Access" color="text-c2" />
          <StatTile icon={<svg width={14} height={14} />} label="Bundles" color="text-brand" />
        </div>

        <ProfileSection kind="bandwidth" />
        <ProfileSection kind="wan_access" />
        <BundleSection filter="data" />
      </div>
    </div>
  );
}

function StatTile({ icon, label, color }: { icon: React.ReactNode; label: string; color: string }) {
  return (
    <div className="card card-pad flex items-center gap-2.5">
      <div className={`w-7 h-7 rounded bg-surface-hi flex items-center justify-center ${color}`}>
        {icon}
      </div>
      <div>
        <div className="text-xs font-semibold">{label}</div>
        <div className="text-[10.5px] text-text-faint">profils + bundles</div>
      </div>
    </div>
  );
}
